import { create } from 'zustand'

const useStore = create((set) => ({
  count1: 1,
  inc: () => set((state) => ({ count1: state.count1 + 1 })),
}))

export default useStore;